export default function TOPICS(){
  $('.toc_title').prepend(`<img src="${window.location.origin}/assets/img/icon-toc.png" width="50">`);
}